import { render, staticRenderFns } from "./ToddsModelsTooltip.vue?vue&type=template&id=36da6219&scoped=true"
import script from "./ToddsModelsTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./ToddsModelsTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ToddsModelsTooltip.vue?vue&type=style&index=0&id=36da6219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da6219",
  null
  
)

export default component.exports